import moment from "moment";
import {useTranslation} from "react-i18next";

const SessionItem = props => {

    const {t} = useTranslation()
    const {stat,onClick} = props
    return (
        <tr key={stat?.timestamp}>
            <td>
                <div className="xtable__text">
                    {/*<img loading="lazy"className={'sml-img'} src={stat?.game?.image} alt="--"/>*/}
                    <a href="#">{stat?.browser ?? t(`general.unknown`)}</a>
                </div>
            </td>
            <td>
                <div className="xtable__text">{stat?.country}</div>
            </td>
            <td>
                <div className="xtable__text">{stat?.ip}</div>
            </td>
            <td>
                <div className="xtable__text">
                    <small>
                        {moment.unix(stat?.timestamp || 0).format('HH:mm:ss')}
                    </small>
                </div>
            </td>

            <td>
                         <span className={`xtable__text xtable__text--${stat.is_active ? 'green' : 'red'}`}>
                            {t(`settings.sessions.${stat.is_active ? 'active' : 'passive'}`)}
                        </span>
            </td>
            <td>
                <div
                    onClick={onClick}
                    className="xtable__text xtable__text--red cursor-pointer">
                    {
                        stat.is_active ?
                            t(`settings.sessions.revoke`) : '-'
                    }
                </div>
            </td>

        </tr>

    )

}

export default SessionItem
